import { AdminPanelEventObserverBase } from "@share/event-edit/observers/AdminPanelEventObserverBase";
import {ObjectResetter} from "@share/common/helpers/ObjectResetter";
import {Modal} from "@common/Modal";
import i18n from "@service/locale/i18";

export class OnResetObserver extends AdminPanelEventObserverBase {
    constructor(protected readonly objectResetter: ObjectResetter) {
        super('onGrey');
    }

    async handler() {
       if (this.objectResetter.needToReset) {
           const modal = new Modal({
               title: i18n.t('common.resetQuestion').toString(),
               buttons: [
                   {
                       text: i18n.t('common.yes').toString(),
                       class: 'is-green',
                       returnValue: true
                   },
                   {
                       text: i18n.t('common.no').toString(),
                       class: 'is-red is-outlined',
                       returnValue: false
                   },
               ]
           });

           const modalResult = await modal.showConfirm(false);

           if (!modalResult) { return; }

           this.objectResetter.reset();
       }
    }
}
